export const makeEmptySelection = () => ({
    selectAll: false,
    query: {
        included: [],
        excluded: [],
        filter: [],
    },
})

// typeof SelectionState = {
//     [selectionKey: string]: {
//         selectAll: boolean
//         query: {
//             included: [],
//             excluded: [],
//             filter: []
//         }
//     }
// }
export default {
    namespaced: true,

    state: {}, // SelectionState

    getters: {
        selectionQuery: state => key => {
            if (!state[key]) return false
            return state[key].query
        },

        selectAll: state => key => {
            if (!state[key]) return false
            return state[key].selectAll
        },

        isSelected: state => (key, id) => {
            if (!state[key]) return false
            const isIncluded = state[key].query.included.includes(id)
            if (isIncluded) return true
            const isExcluded = state[key].query.excluded.includes(id)
            if (isExcluded) return false
            return state[key].selectAll
        },

        selectionObject: (_state, getters) => key => {
            const selectionQuery = getters.selectionQuery(key)
            const selectAll = getters.selectAll(key)
            const isSelected = id => getters.isSelected(key, id)
            return { selectionQuery, selectAll, isSelected }
        },
    },

    mutations: {
        setInstance(state, { key, instance }) {
            if (key in state) {
                Object.assign(state[key], instance)
            } else {
                state[key] = instance
            }
        },

        toggleIncludedItem(state, { key, id }) {
            const query = state[key].query
            const idx = query.included.findIndex(i => i == id)
            if (idx == -1) {
                query.included.push(id)
            } else {
                query.included.splice(idx, 1)
            }
        },

        toggleExcludedItem(state, { key, id }) {
            const query = state[key].query
            const idx = query.excluded.findIndex(i => i == id)
            if (idx == -1) {
                query.excluded.push(id)
            } else {
                query.excluded.splice(idx, 1)
            }
        },

        updateFilter(state, { key, filter }) {
            const query = state[key].query
            if (filter) {
                query.filter[0] = filter
            } else {
                query.filter = []
            }
        },

        setSelectAll(state, { key, value }) {
            const query = state[key]?.query
            if (!query) return
            query.included = []
            query.excluded = []
            state[key].selectAll = value
        },
    },

    actions: {
        init({ state, dispatch }, key) {
            if (key in state) return
            dispatch("clear", key)
        },

        clear({ commit }, key) {
            const instance = makeEmptySelection()
            commit("setInstance", { key, instance })
        },

        toggleSelection({ state, commit }, { key, id }) {
            const selectAll = state[key].selectAll
            if (selectAll) {
                commit("toggleExcludedItem", { key, id })
            } else {
                commit("toggleIncludedItem", { key, id })
            }
        },

        updateFilter({ commit }, { key, filter }) {
            commit("updateFilter", { key, filter })
        },

        toggleSelectAll({ state, commit }, { key }) {
            const value = !state[key].selectAll
            commit("setSelectAll", { key, value })
        },
    },
}
